import { styled } from '@mui/material/styles';
import { ContactUs } from "../components";
import FaqList from "../components/FaqList";
import { Typography } from "@mui/material";
import { faqPageData } from "../data/faqPageData";
import { faqCategoriesData } from "../data/faqCategoriesData";
import HIDDEN_FAQ_IDS_BY_CATEGORY from "../configs/notVisibleFaqs";

const FaqBanner = styled('section')(
  ({ backgroundImgUrl, theme: { palette: { primary }, breakpoints } }) => `
  background: ${primary.main} 0% 0% no-repeat padding-box;
  padding: 97px 0px 70px 22px;
  background-size: 1280px;
  background-image: url(${backgroundImgUrl});
  background-size: cover;
  background-position: 0 -78px !important;
  ${[breakpoints.up('md')]} {
    padding-left: 140px;
  }
`
);

const filteredFaqCategoriesData = faqCategoriesData.map(category => {
  if (HIDDEN_FAQ_IDS_BY_CATEGORY[category?.fields?.name]) {
    const toHideContent = HIDDEN_FAQ_IDS_BY_CATEGORY[category.fields.name];
    let faqEntries = category?.fields?.faqEntries?.filter(entry => !toHideContent.has(entry.sys?.id));
    return {
      ...category,
      fields: {
        ...category.fields,
        faqEntries: faqEntries
      }
    };
  }
  
  return category;
});

const FaqPage = () => {
  const { faqBannerData = {}, contactUsData = {} } = faqPageData;
  const backgroudnImageUrl = faqBannerData?.fields?.backgroundImage?.fields?.file?.url;

  return (
    <>
      <FaqBanner id="faqBanner" backgroundImgUrl={backgroudnImageUrl} data-testid='faqBanner'>
        <Typography variant={'h1'} color='neutral.white' id="deadLine" data-testid='headline'>{faqBannerData?.fields?.title}</Typography>
        <Typography variant={'p1'} mt='15px' color='neutral.white' id="tagLineText" data-testid='tagLineText'>{faqBannerData?.fields?.headline}</Typography>
      </FaqBanner>
      <FaqList faqCategoriesData={filteredFaqCategoriesData} />
      <ContactUs id="contactUs" data={contactUsData}/>
    </>
  );
};

export default FaqPage;
